import React, { Component } from 'react';
import Axios from 'axios';
import './RequestLimits.css';

import Utils from '../../../base/Utils';
import Config from '../../../base/config/Config';

import Description from './../../components/description/Description';
import Loading from './../../components/loading/Loading';

class RequestLimits extends Component {
    constructor(props) {
        super(props);
        
        this.getLimits();
        
        this.state = {
            limits: {
                usage: null,
                month: null, 
                hour: null, 
                minute: null
            }
        };
    }
    
    callback = null;
    
    render() {
        var limits = Utils.checkUsage(this.props.customLimits);
        this.callback = this.props.callback || function(){ };
        
        if(limits === '') limits = this.state.limits;
        
        return <div className="RequestLimits">
        <Description text={<font>
            {(limits.month !== null) ? Utils.divideByThousands(limits.month) : <Loading />} requests per month<br />
            {(limits.hour !== null) ? Utils.divideByThousands(limits.hour) : <Loading />} requests per hour<br />
            {(limits.minute !== null) ? Utils.divideByThousands(limits.minute) : <Loading />} requests per minute<br />
            </font>
        } color="Light" />
        </div>;
    }
    
    getLimits() {
        Axios.get(Config.backendHost + "manage/requests", {withCredentials: true}).then((response) => {
            if(Utils.checkResponse(response)) {
                var data = response.data;
                
                if(data.status === 'success') {
                    data = data.data;

                    this.setLimits(data);
                    
                    this.callback(this.state.limits);
                }
            }
        });
    }
    
    setLimits(data) {
        this.setState({
            limits: {
                usage: data.requestsUsed,
                month: data.requestsPerMonth, 
                hour: data.requestsPerHour, 
                minute: data.requestsPerMinute
            }
        });
        
        this.callback(this.state.limits);
    }
}

export default RequestLimits;
